import React, {Component} from "react"
import PropTypes from "prop-types"
import "./EnterCode.css"

const setCursorPosition = (elem, cursorPosition) => {
  if (elem != null) {
    if (elem.createTextRange) {
      const range = elem.createTextRange()
      range.move("character", cursorPosition)
      range.select()
    } else {
      if (elem.selectionStart) {
        elem.focus()
        elem.setSelectionRange(cursorPosition, cursorPosition)
      } else {
        elem.focus()
      }
    }
  }
}

class EnterCode extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      codeParts: [],
    }
    this.nodes = {}
  }

  componentWillMount() {
    this.setState({
      codeParts: this.props.code ? this.props.code.split("") : [],
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      codeParts: nextProps.code ? nextProps.code.split("") : [],
    })
    const code = nextProps.code ? nextProps.code.replace(/^\s*/, "") : ""
    if (nextProps.code && this.nodes[code.length]) {
      this.nodes[code.length].focus()
      setCursorPosition(this.nodes[code.length], 0)
    }
  }

  handleChange = (index, codePart) => {
    const codeParts = this.state.codeParts
    codeParts[index] = codePart || ""
    this.props.setCode(codeParts.join(""))
  }

  render() {
    const {codeParts} = this.state
    const arr = Array(this.props.codeLength).fill("")
    const that = this

    return (
      <div className="EnterCode">
        {arr.map((placeholder, index) => {
          const handleChange = ev => {
            that.handleChange(index, ev.target.value.substring(0, 1))
            if (ev.target.value) {
              if (that.nodes[index + 1]) {
                that.nodes[index + 1].focus()
              }
            }
          }
          const setNode = node => {
            that.nodes[index] = node
          }
          const handleKeyDown = ev => {
            if (
              (!codeParts[index] || codeParts[index] === " ") &&
              ev.keyCode === 8
            ) {
              if (that.nodes[index - 1]) {
                that.nodes[index - 1].focus()
              }
            }
          }
          return (
            <input
              type="number"
              key={index}
              onChange={handleChange}
              value={codeParts[index] || ""}
              ref={setNode}
              onKeyDown={handleKeyDown}
            />
          )
        })}
      </div>
    )
  }
}

EnterCode.defaultProps = {
  code: "",
  codeLength: 5,
}

EnterCode.propTypes = {
  setCode: PropTypes.func.isRequired,
  codeLength: PropTypes.number.isRequired,
}

export default EnterCode



// WEBPACK FOOTER //
// ./src/component/molecules/EnterCode/index.js